import * as React from "react";

export const Companies: any = [];

Companies[0] = {
    CompanyName: "GAIIL",
    CoexistencesMax: 0.4,
    MaxAgeContributionExtracts: 50,
    MaxAgeMilitaryContributionExtracts: 50,
    MaxSickDays: 10,
    MaxRVMSickDays: 30,
    PovertyMin: 500,
    RVMLimit: 80000,
    ContractType: {
        Undetermined: "",
        DeterminedMinor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato che scade prima della Fine del Piano di Ammortamento",
        DeterminedMajor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato anche se scade dopo la Fine del Piano di Ammortamento"
    },
    WorkingHoursType: {
        FullTime: "",
        VerticalPartTime: "La Compagnia Assicurativa non assicura il Cedente con Part Time Verticale",
        HorizontalPartTime: ""
    },
    WorkTimePercentage: {
        MinValue: 50,
        Message: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro Part Time con una riduzione dell'Orario di Lavoro maggiore del 50%"
    },
    CurrentEmployment: {
        MaxLength: 45,
        Message: "Il Cedente ha superato il requisito massimo di Anzianità di Servizio fissato ad anni 45"
    },
    TotalEmploymentLength: {
        Woman: 42,
        Man: 43
    },
    InsuranceAmount: {
        MaxValue: 50000,
        Message: "Il Capitale da assicurare non può essere superiore ad 50.000,00 €."
    },
    OtherLoansEnd: {
        Message: "In Relazione agli Impegni in corso è necessario che il Cedente estingua tali Impegni"
    },
    EmploymentDate: {
        MinEmploymentMonths: 3,
        Messages: {
            MinEmploymentMonths: "E' prevista un'Anzianità Minima di Servizio non inferiore ai 3 mesi",
            LessThanBirthDay: "La Data di Assunzione non può essere inferiore alla Data di Nascita"
        }
    },
    IsTrialPeriodFinished: {
        TrialPeriod: true,
        Message: "E' necessario che il Cedente abbia superato il Periodo di Prova previsto dal CCNL"
    },
    DateOfBirth: {
        MaxAge: 67,
        Message: "Il Cedente all'Inizio del Piano di Ammortamento ha un'età Anagrafica superione ad anni 67"
    },
    Installment: {
        Messages: {
            EmptyInstallment: "La Rata Ceduta non può essere Nulla",
            NoMaxNoDistraintInstallmentReduction: "NoMaxNoDistraintInstallmentReduction",
            NoMaxNoDistraintNoInstallmentReduction: "",
            NoMaxDistraintInstallmentReduction: "NoMaxDistraintInstallmentReduction",
            NoMaxDistraintNoInstallmentReduction: "NoMaxDistraintNoInstallmentReduction",
            MaxNoDistraintInstallmentReduction: "MaxNoDistraintInstallmentReduction",
            MaxNoDistraintNoInstallmentReduction: "MaxNoDistraintNoInstallmentReduction",
            MaxDistraintInstallmentReduction: "MaxDistraintInstallmentReduction",
            MaxDistraintNoInstallmentReduction: "MaxDistraintNoInstallmentReduction",
            Military: {
                NoMaxNoDistraintInstallmentReduction: "MilitaryNoMaxNoDistraintInstallmentReduction",
                NoMaxNoDistraintNoInstallmentReduction: "",
                NoMaxDistraintInstallmentReduction: "MilitaryNoMaxDistraintInstallmentReduction",
                NoMaxDistraintNoInstallmentReduction: "NoMaxDistraintNoInstallmentReduction",
                MaxNoDistraintInstallmentReduction: "MilitaryMaxNoDistraintInstallmentReduction",
                MaxNoDistraintNoInstallmentReduction: "MaxNoDistraintNoInstallmentReduction",
                MaxDistraintInstallmentReduction: "MilitaryMaxDistraintInstallmentReduction",
                MaxDistraintNoInstallmentReduction: "MaxDistraintNoInstallmentReduction"
            }
        }
    },
    InsuranceAge: {
        MaxValue: 67,
        Message: "All'inizio dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 67"
    },
    FinalInsuranceAge: {
        MaxValue: 999,
        Message: "Alla scadenza dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 999"
    },
    TotalResidualDebt: {
        MiddleValue: 80000,
        MaxValue: 999999999,
        NoCessionMessage: "In ASSENZA di affiancamento di una CESSIONE è NECESSARIA LA PREACCETTAZIONE",
        MiddleValueMessage: "Il Cumulo del Capitale da assicurare e delle Coesistenze non può essere superiore ad 80.000,00 €. In questo caso è necessaria pre-accettazione assicurativa.",
        Message: "Il Cumulo del Capitale da assicurare e delle Coesistenze non può essere superiore ad 80.000,00 €."
    },
    DebtorIsMilitary: {
        PensionAge: 67,
        CombinedPensionAge: 62,
        PensionMonthsOfWork: { Man: 514, Woman: 502 },
        CombinedPensionMonthsOfWork: 456,
        Military: {
            PensionAge: 60,
            CombinedPensionAge: 57,
            PensionMonthsOfWork: { Man: 480, Woman: 480 },
            CombinedPensionMonthsOfWork: 420,
            Messages: {
                Combined: "ll Cedente (Militare) raggiunge i Requisiti Pensionistici del COMBINATO Età (57 anni) e Anzianità (35 anni) durante il Piano di Ammortamento",
                NotCombined: "ll Cedente (Militare) raggiunge i Requisiti Pensionistici di Età (60 anni) e/o Anzianità (40 anni) durante il Piano di Ammortamento"
            }
        },
        Messages: {
            ManCombinedAvailable:
                "ll Cedente (Uomo) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento - Utilizzabile Prodotto 100x100 Unicredit",
            ManCombinedNotAvailable: "ll Cedente (Uomo) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento",
            ManNotCombinedAvailable: "",
            ManNotCombinedNotAvailable: "ll Cedente (Uomo) raggiunge i Requisiti Pensionistici Età (67 anni) e/o Anzianità (42 anni e 10 mesi) durante il Piano di Ammortamento",
            WomanCombinedAvailable:
                "ll Cedente (Donna) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento - Utilizzabile Prodotto 100x100 Unicredit",
            WomanCombinedNotAvailable: "ll Cedente (Donna) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento",
            WomanNotCombinedAvailable: "",
            WomanNotCombinedNotAvailable: "ll Cedente (Donna) raggiunge i Requisiti Pensionistici Età (67 anni) e/o Anzianità (41 anni e 10 mesi) durante il Piano di Ammortamento"
        }
    },
    Documentation: {
        Messages: {
            NoContributingExtractsMaxSickDaysNotExceededNoRvm: "",
            ContributingExtractsMaxSickDaysNotExceededNoRvm: "E' richiesta la presentazione degli Estratti Contributivi",
            NoContributingExtractsMaxSickDaysExceededNoRvm: "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysNotExceededRvm:
                "E' necessaria la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza",
            ContributingExtractsMaxSickDaysExceededNoRvm: "E' richiesta la presentazionme degli Estratti Contributivi e la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysExceededRvm:
                "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio e la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysNotExceededRvm:
                "E' richiesta la presentazione degli Estratti Contributivi e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysExceededRvm:
                "E' richiesta la presentazionme degli Estratti Contributivi, della dichiarazione dell’Amministrazione di rientro regolare in servizio e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza."
        }
    },
    DisponibilitaProdotto100x100Unicredit: {
        _57_true_120: true,
        _57_false_120: true,
        _57_true_108: true,
        _57_false_108: true,
        _57_true_96: true,
        _57_false_96: true,
        _57_true_84: true,
        _57_false_84: true,
        _57_true_72: true,
        _57_false_72: true,
        _57_true_60: false,
        _57_false_60: true,
        _57_true_48: false,
        _57_false_48: false,
        _57_true_36: false,
        _57_false_36: false,
        _57_true_24: false,
        _57_false_24: false,
        _58_true_120: false,
        _58_false_120: false,
        _58_true_108: true,
        _58_false_108: true,
        _58_true_96: true,
        _58_false_96: true,
        _58_true_84: true,
        _58_false_84: true,
        _58_true_72: true,
        _58_false_72: true,
        _58_true_60: false,
        _58_false_60: true,
        _58_true_48: false,
        _58_false_48: true,
        _58_true_36: false,
        _58_false_36: false,
        _58_true_24: false,
        _58_false_24: false,
        _59_true_120: false,
        _59_false_120: false,
        _59_true_108: false,
        _59_false_108: false,
        _59_true_96: true,
        _59_false_96: true,
        _59_true_84: true,
        _59_false_84: true,
        _59_true_72: true,
        _59_false_72: true,
        _59_true_60: false,
        _59_false_60: true,
        _59_true_48: false,
        _59_false_48: true,
        _59_true_36: false,
        _59_false_36: true,
        _59_true_24: false,
        _59_false_24: false,
        _60_true_120: false,
        _60_false_120: false,
        _60_true_108: false,
        _60_false_108: false,
        _60_true_96: false,
        _60_false_96: false,
        _60_true_84: true,
        _60_false_84: true,
        _60_true_72: true,
        _60_false_72: true,
        _60_true_60: false,
        _60_false_60: true,
        _60_true_48: false,
        _60_false_48: true,
        _60_true_36: false,
        _60_false_36: true,
        _60_true_24: false,
        _60_false_24: true
    }
};

Companies[1] = {
    CompanyName: "SGI",
    CoexistencesMax: 0.5,
    MaxAgeContributionExtracts: 50,
    MaxAgeMilitaryContributionExtracts: 50,
    MaxSickDays: 10,
    MaxRVMSickDays: 30,
    PovertyMin: 500,
    RVMLimit: 100000,
    ContractType: {
        Undetermined: "",
        DeterminedMinor: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro a Tempo Determinato che scade prima della Fine del Piano di Ammortamento",
        DeterminedMajor: ""
    },
    WorkingHoursType: {
        FullTime: "",
        VerticalPartTime: "",
        HorizontalPartTime: ""
    },
    WorkTimePercentage: {
        MinValue: 50,
        Message: "La Compagnia Assicurativa non assicura il Cedente con Contratto di lavoro Part Time con una riduzione dell'Orario di Lavoro maggiore del 50%"
    },
    CurrentEmployment: {
        MaxLength: 999,
        Message: "Il Cedente ha superato il requisito massimo di Anzianità di Servizio fissato ad anni 999"
    },
    InsuranceAmount: {
        MaxValue: 40000,
        Message: "Il Capitale da assicurare non può essere superiore ad 40.000,00 €.",
        BlockedValue: 100000,
        BlockedValueMessage: "Il Capitale da assicurare non può essere superiore ad 100.000,00 €. In questo caso è necessaria pre-accettazione assicurativa"
    },
    OtherLoansEnd: {
        Message: "In Relazione agli Impegni in corso è necessario che il Cedente estingua tali Impegni"
    },
    EmploymentDate: {
        MinEmploymentMonths: 6,
        Messages: {
            MinEmploymentMonths: "E' prevista un'Anzianità Minima di Servizio non inferiore ai 6 mesi",
            LessThanBirthDay: "La Data di Assunzione non può essere inferiore alla Data di Nascita"
        }
    },
    IsTrialPeriodFinished: {
        TrialPeriod: false,
        Message: ""
    },
    DateOfBirth: {
        MaxAge: 66,
        Message: "Il Cedente all'Inizio del Piano di Ammortamento ha un'età Anagrafica superione ad anni 66"
    },
    Installment: {
        Messages: {
            EmptyInstallment: "La Rata Ceduta non può essere Nulla",
            NoMaxNoDistraintInstallmentReduction: "NoMaxNoDistraintInstallmentReduction",
            NoMaxNoDistraintNoInstallmentReduction: "",
            NoMaxDistraintInstallmentReduction: "NoMaxDistraintInstallmentReduction",
            NoMaxDistraintNoInstallmentReduction: "NoMaxDistraintNoInstallmentReduction",
            MaxNoDistraintInstallmentReduction: "MaxNoDistraintInstallmentReduction",
            MaxNoDistraintNoInstallmentReduction: "MaxNoDistraintNoInstallmentReduction",
            MaxDistraintInstallmentReduction: "MaxDistraintInstallmentReduction",
            MaxDistraintNoInstallmentReduction: "MaxDistraintNoInstallmentReduction",
            Military: {
                NoMaxNoDistraintInstallmentReduction: "MilitaryNoMaxNoDistraintInstallmentReduction",
                NoMaxNoDistraintNoInstallmentReduction: "",
                NoMaxDistraintInstallmentReduction: "MilitaryNoMaxDistraintInstallmentReduction",
                NoMaxDistraintNoInstallmentReduction: "NoMaxDistraintNoInstallmentReduction",
                MaxNoDistraintInstallmentReduction: "MilitaryMaxNoDistraintInstallmentReduction",
                MaxNoDistraintNoInstallmentReduction: "MaxNoDistraintNoInstallmentReduction",
                MaxDistraintInstallmentReduction: "MilitaryMaxDistraintInstallmentReduction",
                MaxDistraintNoInstallmentReduction: "MaxDistraintNoInstallmentReduction"
            }
        }
    },
    InsuranceAge: {
        MaxValue: 9999,
        Message: "All'inizio dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 9999"
    },
    FinalInsuranceAge: {
        MaxValue: 9999,
        Message: "Alla scadenza dell'Ammortamento l'Età del Cedente non può essere superiore ad anni 9999"
    },
    TotalResidualDebt: {
        MiddleValue: 0,
        MaxValue: 100000,
        NoCessionMessage: "In ASSENZA di affiancamento di una CESSIONE è NECESSARIA LA PREACCETTAZIONE",
        MiddleValueMessage: "",
        Message: "Il Cumulo del Capitale da assicurare e delle Coesistenze non può essere superiore ad 100.000,00 €."
    },
    DebtorIsMilitary: {
        PensionAge: 66,
        CombinedPensionAge: 62,
        PensionMonthsOfWork: { Man: 504, Woman: 504 },
        CombinedPensionMonthsOfWork: 456,
        Military: {
            PensionAge: 60,
            CombinedPensionAge: 60,
            PensionMonthsOfWork: { Man: 480, Woman: 480 },
            CombinedPensionMonthsOfWork: 480,
            Messages: {
                Combined: "ll Cedente (Militare) raggiunge i Requisiti Pensionistici del COMBINATO Età (60 anni) e Anzianità (40 anni) durante il Piano di Ammortamento",
                NotCombined: "ll Cedente (Militare) raggiunge i Requisiti Pensionistici di Età (60 anni) e/o Anzianità (40 anni) durante il Piano di Ammortamento"
            }
        },
        Messages: {
            ManCombinedNotAvailable: "ll Cedente (Uomo) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento",
            ManNotCombinedNotAvailable: "ll Cedente (Uomo) raggiunge i Requisiti Pensionistici di Età (66 anni) e/o Anzianità (42 anni) durante il Piano di Ammortamento",
            WomanCombinedNotAvailable: "ll Cedente (Donna) raggiunge i Requisiti Pensionistici del COMBINATO Quota 100 Età (62 anni) e Anzianità (38 anni) durante il Piano di Ammortamento",
            WomanNotCombinedNotAvailable: "ll Cedente (Donna) raggiunge i Requisiti Pensionistici di Età (66 anni) e/o Anzianità (42 anni) durante il Piano di Ammortamento            "
        }
    },
    Documentation: {
        Messages: {
            NoContributingExtractsMaxSickDaysNotExceededNoRvm: "",
            ContributingExtractsMaxSickDaysNotExceededNoRvm: "E' richiesta la presentazione degli Estratti Contributivi",
            NoContributingExtractsMaxSickDaysExceededNoRvm: "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysNotExceededRvm:
                "E' necessaria la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza",
            ContributingExtractsMaxSickDaysExceededNoRvm: "E' richiesta la presentazionme degli Estratti Contributivi e la dichiarazione dell’Amministrazione di rientro regolare in servizio",
            NoContributingExtractsMaxSickDaysExceededRvm:
                "E' necessaria la dichiarazione dell’Amministrazione di rientro regolare in servizio e la presentazione del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysNotExceededRvm:
                "E' richiesta la presentazione degli Estratti Contributivi e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza.",
            ContributingExtractsMaxSickDaysExceededRvm:
                "E' richiesta la presentazionme degli Estratti Contributivi, della dichiarazione dell’Amministrazione di rientro regolare in servizio e del Rapporto di Visita Medica (RVM). In caso di presenza di Invalidità E' NECESSARIO allegare il Verbale di Prima Istanza."
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/configDPS.ts